import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { OperatorGroupMembershipDto } from '../../../../../api/gen/model/operatorGroupMembershipDto';
import { OperatorGroupService } from '../../../../../api/gen/api/operatorGroup.service';
import { GroupMemberItemComponent } from '../group-member-item/group-member-item.component';

@Component({
  selector: 'app-group-member-list',
  imports: [
    CommonModule,
    MatSnackBarModule,
    GroupMemberItemComponent
  ],
  templateUrl: './group-member-list.component.html',
  styleUrl: './group-member-list.component.scss'
})
export class GroupMemberListComponent {
  @Input() memberships: OperatorGroupMembershipDto[] = [];
  @Input() groupId!: string;
  @Output() memberRemoved = new EventEmitter<string>();

  private operatorGroupService = inject(OperatorGroupService);
  private snackBar = inject(MatSnackBar);

  removingIds = new Set<string>();

  onRemove(membership: OperatorGroupMembershipDto): void {
    const operatorId = membership.operator?.id;
    if (!operatorId || !this.groupId) return;

    this.removingIds.add(operatorId);
    this.operatorGroupService.operatorGroupsOperatorGroupIdOperatorsOperatorIdDelete(this.groupId, operatorId).subscribe({
      next: () => {
        this.removingIds.delete(operatorId);
        this.snackBar.open('Member removed from group', 'Close', { duration: 3000 });
        this.memberRemoved.emit(operatorId);
      },
      error: (error) => {
        console.error('Error removing member:', error);
        this.removingIds.delete(operatorId);
        this.snackBar.open('Failed to remove member', 'Close', { duration: 5000 });
      }
    });
  }
}
